module.exports = __webpack_public_path__ + "img/info.67773514.svg";